import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  FormGroup
} from "reactstrap";
// import { FaPlusCircle } from "react-icons/fa";

const SearchAccount = () => {
  const [filters, setFilters] = useState({
    scheme: "All",
    memberNo: "",
    accountNo: "",
    idNo: "",
    surname: "",
    name: "",
    showAllFilters: false
  });

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFilters({
      ...filters,
      [name]: type === "checkbox" ? checked : value
    });
  };

  return (
    <Container fluid>
      <Card>
        <CardBody>

             <h5>Search Accounts</h5>

          {/* Top row: Add new account + Show all filter options */}
          <Row className="align-items-center mb-3">
            <Col lg={6} className="d-flex align-items-center">

               <Button color="success" size="sm" className="mb-2">
                              + add new account
                            </Button>
            </Col>
            <Col lg={6} className="d-flex align-items-center justify-content-end">
              <Input
                type="checkbox"
                name="showAllFilters"
                checked={filters.showAllFilters}
                onChange={handleChange}
                className="me-2"
              />
               <span>Show all filter options</span>
            </Col>
          </Row>

          {/* Form fields */}
          <Row>
            {/* Left Section */}
            <Col lg={6}>
              <FormGroup>
                <Label>Scheme</Label>
                <Input
                  type="select"
                  name="scheme"
                  value={filters.scheme}
                  onChange={handleChange}
                >
                  <option>All</option>
                  <option>Scheme A</option>
                  <option>Scheme B</option>
                </Input>
              </FormGroup>

              <FormGroup className="mt-3">
                <Label>Member no.</Label>
                <Input
                  type="text"
                  name="memberNo"
                  placeholder="Enter member no."
                  value={filters.memberNo}
                  onChange={handleChange}
                />
              </FormGroup>

              <FormGroup className="mt-3">
                <Label>Account no.</Label>
                <Input
                  type="text"
                  name="accountNo"
                  placeholder="Enter account no."
                  value={filters.accountNo}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>

            {/* Middle Section */}
            <Col lg={6}>
              <FormGroup>
                <Label>ID no.</Label>
                <Input
                  type="text"
                  name="idNo"
                  placeholder="Enter ID no."
                  value={filters.idNo}
                  onChange={handleChange}
                />
              </FormGroup>

              <FormGroup className="mt-3">
                <Label>Surname</Label>
                <Input
                  type="text"
                  name="surname"
                  placeholder="Enter surname"
                  value={filters.surname}
                  onChange={handleChange}
                />
              </FormGroup>

              <FormGroup className="mt-3">
                <Label>Name (or preferred name)</Label>
                <Input
                  type="text"
                  name="name"
                  placeholder="Enter name"
                  value={filters.name}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>

          {/* Buttons */}
          <div className="d-flex justify-content-end mt-4">
            <Button color="secondary" className="me-2">
              Clear
            </Button>
            <Button color="warning">Search</Button>
          </div>
        </CardBody>
      </Card>
    </Container>
  );
};

export default SearchAccount;
